const contentfulPublishedTagFilter = ({ tags = [] }) => tags.includes('contentfulStatus:PUBLISHED');

export default contentfulPublishedTagFilter;
